import { graphql } from '@/lib/graphql';

export const PersonaTemplatesListSubscription = graphql(`
  subscription PersonaTemplatesList {
    personaTemplates(orderBy: [{ featured: DESC }, { sortOrder: ASC }]) {
      id
      name
      category
      featured
      sortOrder
      variables
    }
  }
`);

export const PersonaTemplateSubscription = graphql(`
  subscription PersonaTemplate($templateId: Uuid!) {
    personaTemplatesByPk(id: $templateId) {
      id
      name
      description
      category
      featured
      sortOrder
      variables
      personaName
      personaDescription
      instructions
      greeting
      maxTurns
      outputHandles
    }
  }
`);

export const CreatePersonaTemplateMutation = graphql(`
  mutation CreatePersonaTemplate($object: PersonaTemplatesInsertInput!) {
    insertPersonaTemplatesOne(object: $object) {
      id
    }
  }
`);

export const UpdatePersonaTemplateMutation = graphql(`
  mutation UpdatePersonaTemplate($templateId: Uuid!, $set: PersonaTemplatesSetInput!) {
    updatePersonaTemplatesByPk(pkColumns: { id: $templateId }, _set: $set) {
      id
    }
  }
`);

export const DeletePersonaTemplateMutation = graphql(`
  mutation DeletePersonaTemplate($templateId: Uuid!) {
    deletePersonaTemplatesByPk(id: $templateId) {
      id
    }
  }
`);
